<template>
  <div>
    <Hero />

    <div class="portfolio">
      <PortfolioItem v-for="project in portfolio" :project="project" :key="project.name" />
    </div>

  </div>
</template>

<script>
function shuffle(array) {
  return array;
  // for (let i = array.length - 1; i > 0; i--) {
  //   const j = Math.floor(Math.random() * (i + 1));
  //   [array[i], array[j]] = [array[j], array[i]];
  // }
}

import Hero from '@/components/Hero.vue';
import PortfolioItem from '@/components/Portfolio/Item.vue';

import portfolioData from '@/assets/data/portfolio.js';
shuffle(portfolioData);

export default {
  name: 'Home',
  components: {
    Hero,
    PortfolioItem,
  },
  data() {
    return {
      portfolio: portfolioData,
    }
  }
}
</script>

<style lang="scss">

</style>
